import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import pages from "../seo-pages.json";

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/$/, "") || "/";
    const meta = pages[path];

    const robot = document.head.querySelector("meta[name=robots]");
    if (robot)
      robot.content = meta
        ? "index, follow, max-image-preview:large"
        : "noindex, nofollow";
    if (!meta) {
      document.title = "Área privada | Britosa";
      return;
    }
    const url = `https://mudanzasbritosa.com${path}`;
    document.title = meta.title;
    const set = (attr, key, value) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.append(el);
      }
      el.content = value;
    };
    set("name", "title", meta.title);
    set("name", "description", meta.description);
    set("property", "og:title", meta.title);
    set("property", "og:description", meta.description);
    set("property", "og:url", url);
    set("name", "twitter:title", meta.title);
    set("name", "twitter:description", meta.description);
    let schema = document.getElementById("breadcrumb-schema");
    if (path === "/") {
      schema?.remove();
    } else {
      if (!schema) {
        schema = document.createElement("script");
        schema.id = "breadcrumb-schema";
        schema.type = "application/ld+json";
        document.head.append(schema);
      }
      const rows = [
        {
          "@type": "ListItem",
          position: 1,
          name: "Inicio",
          item: "https://mudanzasbritosa.com/",
        },
      ];
      if (path.startsWith("/servicios/"))
        rows.push({
          "@type": "ListItem",
          position: 2,
          name: "Servicios",
          item: "https://mudanzasbritosa.com/servicios",
        });
      rows.push({
        "@type": "ListItem",
        position: rows.length + 1,
        name: meta.title.split(" | ")[0],
        item: url,
      });
      schema.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: rows,
      });
    }
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = url;
  }, [pathname]);
  return null;
}
